module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-8.da92356e.png";